module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"resetPassword":"Reset Password","newPassword":"New Password","confirmPassword":"Confirm New Password","submit":"Submit","invalidSubject":"The token is invalid"},"de":{"resetPassword":"Passwort Zurücksetzen","newPassword":"Neues Password","confirmPassword":"Neues Passwort bestätigen","submit":"Weiter","invalidSubject":"Das Token ist ungültig"}}')
  delete Component.options._Ctor
}
